import { render, staticRenderFns } from "./MonerisCreditCard.vue?vue&type=template&id=1489f123"
import script from "./MonerisCreditCard.vue?vue&type=script&lang=ts"
export * from "./MonerisCreditCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports